import angular                 from 'angular';
import {VerHistorialComponent} from './ver/ver-historial.component';
import {HistorialComponent}    from './historial.component';
import HistorialService        from './historial.service';

/*@ngInject*/
let routesHistorial = function ($routeProvider) {
    $routeProvider
        .when('/historial', {
            template: '<historial-list historial="$resolve.historial.data"></historial-list>',
            authenticate: true,
            administrator: false,
            resolve: {
                historial: getHistorial
            }
        })
        .when('/historial/:id', {
            template: '<historial-detail orden="$resolve.orden.data"></historial-detail>',
            authenticate: true,
            administrator: false,
            resolve: {
                orden: getHistorialDetail
            }
        });

    function getHistorialDetail(HistorialService, $route) {
        return HistorialService.getHistorialDetail($route.current.params.id);
    }

    function getHistorial(HistorialService) {
        return HistorialService.getHistorial(20);
    }
};
export default angular.module('pizzuto-autopartes.historial', [])
    .config(routesHistorial)
    .component(HistorialComponent.selector, HistorialComponent)
    .component(VerHistorialComponent.selector, VerHistorialComponent)
    .service('HistorialService', HistorialService)
    .name;



// WEBPACK FOOTER //
// ./client/app/historial-route/index.js